export enum DidYouForgetCategory {
  InspiredPick,
  MerchZone,
  DyF,
}
